import React, { useState } from "react";
import Body from "./Body";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";

const Students = () => {
  const [classRepresentativeData, setClassRepresentativeData] = useState([
    {
      _id: "a1b2c3d4",
      name: "Ayaan Rahman",
      class: "1",
      section: "A",
    },
    {
      _id: "e5f6g7h8",
      name: "Samiha Akter",
      class: "2",
      section: "B",
    },
    {
      _id: "i9j1k2l3",
      name: "Rafiul Islam",
      class: "3",
      section: "C",
    },
    {
      _id: "m4n5o6p7",
      name: "Tanzila Noor",
      class: "4",
      section: "D",
    },
    {
      _id: "q8r9s1t2",
      name: "Hasib Mahmud",
      class: "5",
      section: "E",
    },
    {
      _id: "u3v4w5x6",
      name: "Nadia Hasan",
      class: "6",
      section: "A",
    },
    {
      _id: "y7z8a9b1",
      name: "Zahin Chowdhury",
      class: "7",
      section: "B",
    },
    {
      _id: "c2d3e4f5",
      name: "Mahin Hossain",
      class: "8",
      section: "C",
    },
    {
      _id: "g6h7i8j9",
      name: "Farzana Karim",
      class: "9",
      section: "D",
    },
    {
      _id: "k1l2m3n4",
      name: "Rayhan Siddique",
      class: "10",
      section: "E",
    },
  ]);
  const [studentsData, setStudentsData] = useState([
    {
      name: "Student 1",
      gender: "Male",
      id: "SM1000000",
      class: "Class 6",
      reportingTeacher: {
        name: "Teacher 1",
        id: "34567100",
      },
      attendance: "60%",
      performance: {
        score: "50%",
        trend: "Down",
      },
      latestPayment: "August",
      subjectStrength: "Math",
      subjectWeakness: "Physics",
      extraActivity: "Sports",
      behavior: "Excellent",
      achievements: [
        "Winner of Science Olympiad",
        "Participated in National Science Fair",
      ],
      likeToDo: "Reading",
      address: "10 Greenway Avenue, City 0, PIN-400000",
    },
    {
      name: "Student 2",
      gender: "Female",
      id: "SM1000001",
      class: "Class 7",
      reportingTeacher: {
        name: "Teacher 2",
        id: "34567101",
      },
      attendance: "61%",
      performance: {
        score: "51%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "Science",
      subjectWeakness: "Chemistry",
      extraActivity: "Music",
      behavior: "Good",
      achievements: [
        "State-Level Football Champion",
        "Completed Advanced Athletics Training",
      ],
      likeToDo: "Dancing",
      address: "11 Greenway Avenue, City 1, PIN-400001",
    },
    {
      name: "Student 3",
      gender: "Male",
      id: "SM1000002",
      class: "Class 8",
      reportingTeacher: {
        name: "Teacher 3",
        id: "34567102",
      },
      attendance: "62%",
      performance: {
        score: "52%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "English",
      subjectWeakness: "Math",
      extraActivity: "Debate",
      behavior: "Average",
      achievements: [],
      likeToDo: "Painting",
      address: "12 Greenway Avenue, City 2, PIN-400002",
    },
    {
      name: "Student 4",
      gender: "Female",
      id: "SM1000003",
      class: "Class 9",
      reportingTeacher: {
        name: "Teacher 4",
        id: "34567103",
      },
      attendance: "63%",
      performance: {
        score: "53%",
        trend: "Down",
      },
      latestPayment: "August",
      subjectStrength: "Biology",
      subjectWeakness: "English",
      extraActivity: "Coding",
      behavior: "Outstanding",
      achievements: ["Debate Champion", "Won Regional Debate Competition"],
      likeToDo: "Gaming",
      address: "13 Greenway Avenue, City 3, PIN-400003",
    },
    {
      name: "Student 5",
      gender: "Male",
      id: "SM1000004",
      class: "Class 10",
      reportingTeacher: {
        name: "Teacher 5",
        id: "34567104",
      },
      attendance: "64%",
      performance: {
        score: "54%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "History",
      subjectWeakness: "Biology",
      extraActivity: "Leadership",
      behavior: "Needs Improvement",
      achievements: [
        "Math Olympiad Finalist",
        "Certified in Advanced Mathematics",
      ],
      likeToDo: "Singing",
      address: "14 Greenway Avenue, City 4, PIN-400004",
    },
    {
      name: "Student 6",
      gender: "Female",
      id: "SM1000005",
      class: "Class 11",
      reportingTeacher: {
        name: "Teacher 1",
        id: "34567105",
      },
      attendance: "65%",
      performance: {
        score: "55%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "Math",
      subjectWeakness: "Physics",
      extraActivity: "Sports",
      behavior: "Excellent",
      achievements: [
        "Winner of Science Olympiad",
        "Participated in National Science Fair",
      ],
      likeToDo: "Reading",
      address: "15 Greenway Avenue, City 5, PIN-400005",
    },
    {
      name: "Student 7",
      gender: "Male",
      id: "SM1000006",
      class: "Class 6",
      reportingTeacher: {
        name: "Teacher 2",
        id: "34567106",
      },
      attendance: "66%",
      performance: {
        score: "56%",
        trend: "Down",
      },
      latestPayment: "August",
      subjectStrength: "Science",
      subjectWeakness: "Chemistry",
      extraActivity: "Music",
      behavior: "Good",
      achievements: [
        "State-Level Football Champion",
        "Completed Advanced Athletics Training",
      ],
      likeToDo: "Dancing",
      address: "16 Greenway Avenue, City 6, PIN-400006",
    },
    {
      name: "Student 8",
      gender: "Female",
      id: "SM1000007",
      class: "Class 7",
      reportingTeacher: {
        name: "Teacher 3",
        id: "34567107",
      },
      attendance: "67%",
      performance: {
        score: "57%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "English",
      subjectWeakness: "Math",
      extraActivity: "Debate",
      behavior: "Average",
      achievements: [],
      likeToDo: "Painting",
      address: "17 Greenway Avenue, City 7, PIN-400007",
    },
    {
      name: "Student 9",
      gender: "Male",
      id: "SM1000008",
      class: "Class 8",
      reportingTeacher: {
        name: "Teacher 4",
        id: "34567108",
      },
      attendance: "68%",
      performance: {
        score: "58%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "Biology",
      subjectWeakness: "English",
      extraActivity: "Coding",
      behavior: "Outstanding",
      achievements: ["Debate Champion", "Won Regional Debate Competition"],
      likeToDo: "Gaming",
      address: "18 Greenway Avenue, City 8, PIN-400008",
    },
    {
      name: "Student 10",
      gender: "Female",
      id: "SM1000009",
      class: "Class 9",
      reportingTeacher: {
        name: "Teacher 5",
        id: "34567109",
      },
      attendance: "69%",
      performance: {
        score: "59%",
        trend: "Down",
      },
      latestPayment: "August",
      subjectStrength: "History",
      subjectWeakness: "Biology",
      extraActivity: "Leadership",
      behavior: "Needs Improvement",
      achievements: [
        "Math Olympiad Finalist",
        "Certified in Advanced Mathematics",
      ],
      likeToDo: "Singing",
      address: "19 Greenway Avenue, City 9, PIN-400009",
    },
    {
      name: "Student 11",
      gender: "Male",
      id: "SM1000010",
      class: "Class 10",
      reportingTeacher: {
        name: "Teacher 1",
        id: "34567110",
      },
      attendance: "70%",
      performance: {
        score: "60%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "Math",
      subjectWeakness: "Physics",
      extraActivity: "Sports",
      behavior: "Excellent",
      achievements: [
        "Winner of Science Olympiad",
        "Participated in National Science Fair",
      ],
      likeToDo: "Reading",
      address: "20 Greenway Avenue, City 0, PIN-400000",
    },
    {
      name: "Student 12",
      gender: "Female",
      id: "SM1000011",
      class: "Class 11",
      reportingTeacher: {
        name: "Teacher 2",
        id: "34567111",
      },
      attendance: "71%",
      performance: {
        score: "61%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "Science",
      subjectWeakness: "Chemistry",
      extraActivity: "Music",
      behavior: "Good",
      achievements: [
        "State-Level Football Champion",
        "Completed Advanced Athletics Training",
      ],
      likeToDo: "Dancing",
      address: "21 Greenway Avenue, City 1, PIN-400001",
    },
    {
      name: "Student 13",
      gender: "Male",
      id: "SM1000012",
      class: "Class 6",
      reportingTeacher: {
        name: "Teacher 3",
        id: "34567112",
      },
      attendance: "72%",
      performance: {
        score: "62%",
        trend: "Down",
      },
      latestPayment: "August",
      subjectStrength: "English",
      subjectWeakness: "Math",
      extraActivity: "Debate",
      behavior: "Average",
      achievements: [],
      likeToDo: "Painting",
      address: "22 Greenway Avenue, City 2, PIN-400002",
    },
    {
      name: "Student 14",
      gender: "Female",
      id: "SM1000013",
      class: "Class 7",
      reportingTeacher: {
        name: "Teacher 4",
        id: "34567113",
      },
      attendance: "73%",
      performance: {
        score: "63%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "Biology",
      subjectWeakness: "English",
      extraActivity: "Coding",
      behavior: "Outstanding",
      achievements: ["Debate Champion", "Won Regional Debate Competition"],
      likeToDo: "Gaming",
      address: "23 Greenway Avenue, City 3, PIN-400003",
    },
    {
      name: "Student 15",
      gender: "Male",
      id: "SM1000014",
      class: "Class 8",
      reportingTeacher: {
        name: "Teacher 5",
        id: "34567114",
      },
      attendance: "74%",
      performance: {
        score: "64%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "History",
      subjectWeakness: "Biology",
      extraActivity: "Leadership",
      behavior: "Needs Improvement",
      achievements: [
        "Math Olympiad Finalist",
        "Certified in Advanced Mathematics",
      ],
      likeToDo: "Singing",
      address: "24 Greenway Avenue, City 4, PIN-400004",
    },
    {
      name: "Student 16",
      gender: "Female",
      id: "SM1000015",
      class: "Class 9",
      reportingTeacher: {
        name: "Teacher 1",
        id: "34567115",
      },
      attendance: "75%",
      performance: {
        score: "65%",
        trend: "Down",
      },
      latestPayment: "August",
      subjectStrength: "Math",
      subjectWeakness: "Physics",
      extraActivity: "Sports",
      behavior: "Excellent",
      achievements: [
        "Winner of Science Olympiad",
        "Participated in National Science Fair",
      ],
      likeToDo: "Reading",
      address: "25 Greenway Avenue, City 5, PIN-400005",
    },
    {
      name: "Student 17",
      gender: "Male",
      id: "SM1000016",
      class: "Class 10",
      reportingTeacher: {
        name: "Teacher 2",
        id: "34567116",
      },
      attendance: "76%",
      performance: {
        score: "66%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "Science",
      subjectWeakness: "Chemistry",
      extraActivity: "Music",
      behavior: "Good",
      achievements: [
        "State-Level Football Champion",
        "Completed Advanced Athletics Training",
      ],
      likeToDo: "Dancing",
      address: "26 Greenway Avenue, City 6, PIN-400006",
    },
    {
      name: "Student 18",
      gender: "Female",
      id: "SM1000017",
      class: "Class 11",
      reportingTeacher: {
        name: "Teacher 3",
        id: "34567117",
      },
      attendance: "77%",
      performance: {
        score: "67%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "English",
      subjectWeakness: "Math",
      extraActivity: "Debate",
      behavior: "Average",
      achievements: [],
      likeToDo: "Painting",
      address: "27 Greenway Avenue, City 7, PIN-400007",
    },
    {
      name: "Student 19",
      gender: "Male",
      id: "SM1000018",
      class: "Class 6",
      reportingTeacher: {
        name: "Teacher 4",
        id: "34567118",
      },
      attendance: "78%",
      performance: {
        score: "68%",
        trend: "Down",
      },
      latestPayment: "August",
      subjectStrength: "Biology",
      subjectWeakness: "English",
      extraActivity: "Coding",
      behavior: "Outstanding",
      achievements: ["Debate Champion", "Won Regional Debate Competition"],
      likeToDo: "Gaming",
      address: "28 Greenway Avenue, City 8, PIN-400008",
    },
    {
      name: "Student 20",
      gender: "Female",
      id: "SM1000019",
      class: "Class 7",
      reportingTeacher: {
        name: "Teacher 5",
        id: "34567119",
      },
      attendance: "79%",
      performance: {
        score: "69%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "History",
      subjectWeakness: "Biology",
      extraActivity: "Leadership",
      behavior: "Needs Improvement",
      achievements: [
        "Math Olympiad Finalist",
        "Certified in Advanced Mathematics",
      ],
      likeToDo: "Singing",
      address: "29 Greenway Avenue, City 9, PIN-400009",
    },
    {
      name: "Student 21",
      gender: "Male",
      id: "SM1000020",
      class: "Class 8",
      reportingTeacher: {
        name: "Teacher 1",
        id: "34567120",
      },
      attendance: "80%",
      performance: {
        score: "70%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "Math",
      subjectWeakness: "Physics",
      extraActivity: "Sports",
      behavior: "Excellent",
      achievements: [
        "Winner of Science Olympiad",
        "Participated in National Science Fair",
      ],
      likeToDo: "Reading",
      address: "30 Greenway Avenue, City 0, PIN-400000",
    },
    {
      name: "Student 22",
      gender: "Female",
      id: "SM1000021",
      class: "Class 9",
      reportingTeacher: {
        name: "Teacher 2",
        id: "34567121",
      },
      attendance: "81%",
      performance: {
        score: "71%",
        trend: "Down",
      },
      latestPayment: "August",
      subjectStrength: "Science",
      subjectWeakness: "Chemistry",
      extraActivity: "Music",
      behavior: "Good",
      achievements: [
        "State-Level Football Champion",
        "Completed Advanced Athletics Training",
      ],
      likeToDo: "Dancing",
      address: "31 Greenway Avenue, City 1, PIN-400001",
    },
    {
      name: "Student 23",
      gender: "Male",
      id: "SM1000022",
      class: "Class 10",
      reportingTeacher: {
        name: "Teacher 3",
        id: "34567122",
      },
      attendance: "82%",
      performance: {
        score: "72%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "English",
      subjectWeakness: "Math",
      extraActivity: "Debate",
      behavior: "Average",
      achievements: [],
      likeToDo: "Painting",
      address: "32 Greenway Avenue, City 2, PIN-400002",
    },
    {
      name: "Student 24",
      gender: "Female",
      id: "SM1000023",
      class: "Class 11",
      reportingTeacher: {
        name: "Teacher 4",
        id: "34567123",
      },
      attendance: "83%",
      performance: {
        score: "73%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "Biology",
      subjectWeakness: "English",
      extraActivity: "Coding",
      behavior: "Outstanding",
      achievements: ["Debate Champion", "Won Regional Debate Competition"],
      likeToDo: "Gaming",
      address: "33 Greenway Avenue, City 3, PIN-400003",
    },
    {
      name: "Student 25",
      gender: "Male",
      id: "SM1000024",
      class: "Class 6",
      reportingTeacher: {
        name: "Teacher 5",
        id: "34567124",
      },
      attendance: "84%",
      performance: {
        score: "74%",
        trend: "Down",
      },
      latestPayment: "August",
      subjectStrength: "History",
      subjectWeakness: "Biology",
      extraActivity: "Leadership",
      behavior: "Needs Improvement",
      achievements: [
        "Math Olympiad Finalist",
        "Certified in Advanced Mathematics",
      ],
      likeToDo: "Singing",
      address: "34 Greenway Avenue, City 4, PIN-400004",
    },
    {
      name: "Student 26",
      gender: "Female",
      id: "SM1000025",
      class: "Class 7",
      reportingTeacher: {
        name: "Teacher 1",
        id: "34567125",
      },
      attendance: "85%",
      performance: {
        score: "75%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "Math",
      subjectWeakness: "Physics",
      extraActivity: "Sports",
      behavior: "Excellent",
      achievements: [
        "Winner of Science Olympiad",
        "Participated in National Science Fair",
      ],
      likeToDo: "Reading",
      address: "35 Greenway Avenue, City 5, PIN-400005",
    },
    {
      name: "Student 27",
      gender: "Male",
      id: "SM1000026",
      class: "Class 8",
      reportingTeacher: {
        name: "Teacher 2",
        id: "34567126",
      },
      attendance: "86%",
      performance: {
        score: "76%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "Science",
      subjectWeakness: "Chemistry",
      extraActivity: "Music",
      behavior: "Good",
      achievements: [
        "State-Level Football Champion",
        "Completed Advanced Athletics Training",
      ],
      likeToDo: "Dancing",
      address: "36 Greenway Avenue, City 6, PIN-400006",
    },
    {
      name: "Student 28",
      gender: "Female",
      id: "SM1000027",
      class: "Class 9",
      reportingTeacher: {
        name: "Teacher 3",
        id: "34567127",
      },
      attendance: "87%",
      performance: {
        score: "77%",
        trend: "Down",
      },
      latestPayment: "August",
      subjectStrength: "English",
      subjectWeakness: "Math",
      extraActivity: "Debate",
      behavior: "Average",
      achievements: [],
      likeToDo: "Painting",
      address: "37 Greenway Avenue, City 7, PIN-400007",
    },
    {
      name: "Student 29",
      gender: "Male",
      id: "SM1000028",
      class: "Class 10",
      reportingTeacher: {
        name: "Teacher 4",
        id: "34567128",
      },
      attendance: "88%",
      performance: {
        score: "78%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "Biology",
      subjectWeakness: "English",
      extraActivity: "Coding",
      behavior: "Outstanding",
      achievements: ["Debate Champion", "Won Regional Debate Competition"],
      likeToDo: "Gaming",
      address: "38 Greenway Avenue, City 8, PIN-400008",
    },
    {
      name: "Student 30",
      gender: "Female",
      id: "SM1000029",
      class: "Class 11",
      reportingTeacher: {
        name: "Teacher 5",
        id: "34567129",
      },

      attendance: "89%",
      performance: {
        score: "79%",
        trend: "Up",
      },
      latestPayment: "August",
      subjectStrength: "History",
      subjectWeakness: "Biology",
      extraActivity: "Leadership",
      behavior: "Needs Improvement",
      achievements: [
        "Math Olympiad Finalist",
        "Certified in Advanced Mathematics",
      ],
      likeToDo: "Singing",
      address: "39 Greenway Avenue, City 9, PIN-400009",
    },
  ]);
  const changeBehavior = (_id) => {
    console.log(_id);
  };
  const [genderWaysFilter, setGenderWaysFilter] = useState("");

  const flatData = studentsData?.map((s) => ({
    Name: s.name,
    Gender: s.gender,
    StudentID: s.id,
    Class: s.class,
    ReportingTeacherName: s.reportingTeacher?.name,
    ReportingTeacherID: s.reportingTeacher?.id,
    Attendance: s.attendance,
    Score: s.performance?.score,
    Trend: s.performance?.trend,
    LatestPayment: s.latestPayment,
    SubjectStrength: s.subjectStrength,
    SubjectWeakness: s.subjectWeakness,
    ExtraActivity: s.extraActivity,
    Behavior: s.behavior,
    Achievements: s.achievements?.join(", "), // convert array to string
    LikeToDo: s.likeToDo,
    Address: s.address,
  }));
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(flatData);

    // Get header keys
    const headerKeys = Object.keys(flatData[0]);

    // Apply bold to header row
    headerKeys.forEach((key, index) => {
      const cellRef = XLSX.utils.encode_cell({ c: index, r: 0 }); // r:0 = first row
      if (!worksheet[cellRef]) return;

      worksheet[cellRef].s = {
        font: {
          bold: true,
          color: { rgb: "000000" },
        },
        fill: {
          fgColor: { rgb: "E5E5E5" },
        },
        alignment: {
          horizontal: "center",
        },
        border: {
          bottom: {
            style: "thin",
            color: { rgb: "000000" },
          },
        },
      };
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Students");

    const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([buffer], { type: "application/octet-stream" });
    saveAs(blob, "Student_data.xlsx");
  };
  const _this = {
    classRepresentativeData,
    setClassRepresentativeData,
    studentsData,
    setStudentsData,
    changeBehavior,
    genderWaysFilter,
    setGenderWaysFilter,
    exportToExcel,
  };
  return <Body {..._this} />;
};

export default Students;
